import React from "react";
import "../styles/vision.css";
export default function Testimonials() {
  return (
    <>
      <div className="textAlign container">
        <h1 className="containerH1">Impact Metrics for RetroPGF 3</h1>
        <ul>
         <li>
         50 % increase in OP user & developer adoption with OP Nodekit modules. Please visit details at the google doc:{" "} 
         <a href="https://docs.google.com/document/d/1QRQYxy1E0-bXzhVB94SsWzIfZgUUHTvF94FvC-VzU0Y/edit?usp=sharing"> OP Nodekit's Evolution, Impact and Consideration for OP RetroPGF3
         </a> and at the google doc:{" "}  
         <a href="https://docs.google.com/spreadsheets/d/1--Uf2h932UvySq-K7KARI9zaRM_kuQrUQe0EIDyIFKI/edit?usp=drive_link"> OP Nodekit's impact metrics for OPRetroPGF3
         </a>  
          </li>
          <li>
            5 Developer and DAO tools on optimism for organization, tabulation,
            visualization of on-chain and off-chain data
          </li>
          <li>
            7 Low code tools to enable automation, feedback and asset management
          </li>
          <li>4 Developer tools for NFT creation, management and marketplaces</li>
          <li>
          Optimism Ecosystem Grants and Community Impact with OP Nodekit Modules. Please visit details at the google doc:{" "}  
         <a href="https://docs.google.com/document/d/1Ay4FOKHwTfHNyqIr7wYaopg887oe1y19j9OymiRDFPk/edit?usp=drive_link"> OP Nodekit Projects' Grants and Prizes
         </a>
          </li>
          <li>
            Client Testimonials by Tech Swarm, Samsung Innovation Labs at NSUT, Thales Group, ZF Mobility, N.S.U.T. I.I.F. and Enzen Consulting.
          </li>
          <li>
            Technical consultant and adviser at N.S.U.T.'s optimism eco-system initiative.
          </li>
          <li>
            Collaboration with optimism projects like Mode, Wormhole, Base and MUD; zero knowledge proofs and privacy preserving initiatives, models.
          </li>
          <li>
          Great support by EthGlobal’s OP community in contributing to OP eco-system.
          </li>
        </ul>
      </div>
      <br />
    </>
  );
}
